import { useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import fileDownload from "js-file-download";
import handleApiError from "../helpers/handleApiError";

import { ExportIcon } from "./Utility/Icons/ExportIcon";

/*
interface ExcelExportDataActionProps {
    className?: string;
    alt?: string;
    title?: string;
    fileName?: string;
    getExportData: () => Promise<unknown>;
}
*/

function ExcelExportDataAction({
  className,
  getExportData,
  title,
  alt = "Export Data",
  fileName = "Exported data",
}) {
  if (!getExportData || !title)
    throw new Error("getExportData and title props are required");

  const history = useHistory();

  const { data: claimsExcelData } = useQuery({
    queryKey: ["claims"],
    queryFn: () => getExportData(),
    refetchOnWindowFocus: false,
    onError: (error) => handleApiError(error, history),
  });

  const handleOnClickRequest = () => {
    if (!claimsExcelData?.data) return;

    fileDownload(
      claimsExcelData?.data,
      `${fileName} - ${new Date().toLocaleDateString()}.xlsx`
    );
  };

  return (
    <button
      className={className}
      type="button"
      onClick={handleOnClickRequest}
      style={{
        border: "transparent",
        background: "none",
        outline: "none",
      }}
    >
      <ExportIcon alt={alt} title={title} size={25} />
      {/* <img src={exportIcon} alt={alt} title={title} width="30px" /> */}
    </button>
  );
}

export default ExcelExportDataAction;
